[
   {
      "display": "true",
      "ui_columnname": "Action",
      "db_columnname": "",
      "datatype": "char",
      "mappingkey": "",
      "dropdown": "NO",
      "isdefault": "false",
      "disabled": "true",
      "value": "",
      "dropdowntype": "singleselect",
      "dropdownvalue": ""
   },
   {
       "display":"true",
       "ui_columnname":"MPID",
       "db_columnname":"FirmMPID",
       "datatype":"String",
       "mappingkey":"FirmMPID",
       "dropdown":"NO",
       "disabled":"true",
       "value":"",
       "dropdownvalue":""
    },
    {
        "display":"true",
        "ui_columnname":"User ID",
        "db_columnname":"User_ID",
        "datatype":"String",
        "mappingkey":"User_ID",
        "dropdown":"NO",
        "disabled":"true",
        "value":"",
        "dropdownvalue":""
     },
     {
        "display":"true",
        "ui_columnname":"Created Date",
        "db_columnname":"Created_Date",
        "datatype":"String",
        "mappingkey":"Created_Date",
        "dropdown":"NO",
        "disabled":"true",
        "value":"",
        "dropdownvalue":""
     },
     {
        "display":"true",
        "ui_columnname":"User Action",
        "db_columnname":"User_Action",
        "datatype":"String",
        "mappingkey":"User_Action",
        "dropdown":"NO",
        "disabled":"true",
        "value":"",
        "dropdownvalue":""
     },
     {
        "display":"true",
        "ui_columnname":"Application",
        "db_columnname":"Application",
        "datatype":"String",
        "mappingkey":"Application",
        "dropdown":"NO",
        "disabled":"true",
        "value":"",
        "dropdownvalue":""
     },
     {
        "display":"true",
        "ui_columnname":"Activity",
        "db_columnname":"Text1",
        "datatype":"String",
        "mappingkey":"Text1",
        "dropdown":"NO",
        "disabled":"true",
        "value":"",
        "dropdownvalue":""
     },
     {
        "display":"true",
        "ui_columnname":"Activity Detail",
        "db_columnname":"Text2",
        "datatype":"String",
        "mappingkey":"Text2",
        "dropdown":"NO",
        "disabled":"true",
        "value":"",
        "dropdownvalue":""
     }
]